module.exports = __webpack_public_path__ + "static/media/hat-witch.3d355813.svg";